import { createFileRoute } from '@tanstack/react-router';

import { PostCardConcepts } from '#modules/finder/components/PostCardConcepts';

export const Route = createFileRoute('/{-$locale}/_layout/preview/post-card-concepts')({
  component: PostCardConceptsPreview,
  ssr: false,
});

function PostCardConceptsPreview() {
  const { locale } = Route.useParams();
  return <PostCardConcepts locale={locale === 'ru' ? 'ru' : 'en'} />;
}
